// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"2t0wY":[function(require,module,exports,__globalThis) {
/**
 * Contact Return Button
 * Handles the up arrow button that appears in section 6 (contact)
 * - Shows when arriving at contact section (especially from section 3)
 * - Scrolls back to section 3 when clicked, then fades out
 * - Fades out when scrolled out of viewport
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gsap = require("gsap");
class ContactReturnButton {
    constructor(){
        this.btn = null;
        this.contactSection = null;
        this.aboutSection = null;
        this.isVisible = false;
        this.hasBeenClicked = false;
        this.rafId = null;
        this.init();
    }
    init() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>this.setup());
        else this.setup();
    }
    setup() {
        this.btn = document.querySelector('.contact-return-btn');
        this.contactSection = document.getElementById('contact');
        this.aboutSection = document.getElementById('about');
        if (!this.btn || !this.contactSection || !this.aboutSection) {
            console.warn('ContactReturnButton: Required elements not found');
            return;
        }
        // Start with button hidden
        this.btn.classList.add('is-hidden');
        this.isVisible = false;
        // Set up click handler
        this.btn.addEventListener('click', ()=>this.handleClick());
        // Start monitoring scroll
        this.startMonitoring();
    }
    handleClick() {
        if (this.hasBeenClicked) return;
        this.hasBeenClicked = true;
        // Scroll to about section (section 3, index 2)
        const targetPosition = this.aboutSection.offsetTop;
        if (window.smoothScroll && typeof window.smoothScroll.scrollTo === 'function') window.smoothScroll.scrollTo(targetPosition, 1200);
        else window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
        // Fade out the button
        (0, _gsap.gsap).to(this.btn, {
            opacity: 0,
            duration: 0.4,
            ease: 'power2.inOut',
            onComplete: ()=>{
                this.btn.classList.add('is-hidden');
                this.isVisible = false;
            }
        });
    }
    startMonitoring() {
        const monitor = ()=>{
            this.updateButtonVisibility();
            this.rafId = requestAnimationFrame(monitor);
        };
        this.rafId = requestAnimationFrame(monitor);
    }
    updateButtonVisibility() {
        // Get scroll position
        const scrollY = window.smoothScroll?.scrollCurrent ?? window.scrollY;
        // Get contact section bounds
        const contactTop = this.contactSection.offsetTop;
        const contactBottom = contactTop + this.contactSection.offsetHeight;
        // Get button position in viewport
        const btnRect = this.btn.getBoundingClientRect();
        const btnInViewport = btnRect.top >= 0 && btnRect.bottom <= window.innerHeight;
        // Check if we're in contact section
        const viewportMid = scrollY + window.innerHeight / 2;
        const isInContactSection = viewportMid >= contactTop && viewportMid < contactBottom;
        // If button was already clicked, keep it hidden
        if (this.hasBeenClicked) {
            if (this.isVisible) this.fadeOut();
            return;
        }
        // Only show button if:
        // 1. We arrived via the Contact Me button
        // 2. We're in the contact section
        // 3. The button is in viewport
        if (window.__arrivedViaContactButton && isInContactSection && btnInViewport && !this.isVisible) this.fadeIn();
        else if ((!isInContactSection || !btnInViewport) && this.isVisible) {
            // Hide if we left contact section OR button scrolled out of viewport
            this.fadeOut();
            // Reset the flag when button is hidden
            if (window.__arrivedViaContactButton) window.__arrivedViaContactButton = false;
        }
    }
    fadeIn() {
        this.isVisible = true;
        this.btn.classList.remove('is-hidden');
        (0, _gsap.gsap).to(this.btn, {
            opacity: 1,
            duration: 0.4,
            ease: 'power2.inOut'
        });
    }
    fadeOut() {
        this.isVisible = false;
        (0, _gsap.gsap).to(this.btn, {
            opacity: 0,
            duration: 0.4,
            ease: 'power2.inOut',
            onComplete: ()=>{
                this.btn.classList.add('is-hidden');
            }
        });
    }
    destroy() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
    }
}
// Initialize
const contactReturnButton = new ContactReturnButton();
// Expose globally so index.js can reset the state
window.contactReturnButton = contactReturnButton;
exports.default = contactReturnButton;

},{"gsap":"kKW9v","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["2t0wY"], "2t0wY", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.1b6e58cc.js.map
